import React from "react"
import { Card, CardBody, Spinner } from "reactstrap"
import TradingCard from "../Components/TradingCard"
import MetamaskLogo from "../assets/images/metamask.png"

const Collectibles = (props) => {
    const { items, loading, isConnectedToWallet, connectWallet } = props

    return (
        <React.Fragment>
            <div className="content trading-page">
                <Card>
                    <CardBody>
                        {loading && (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 400 }}>
                                <Spinner size="lg" color="primary" />
                            </div>
                        )}
                        {loading || items.length ? (
                            <div className="card-list">
                                {!loading &&
                                    items.map((item, index) => (
                                        <TradingCard
                                            data={item}
                                            key={index}
                                            sell={true}
                                            isConnectedToWallet={isConnectedToWallet}
                                            connectWallet={connectWallet}
                                        />
                                    ))}
                            </div>
                        ) : (
                            <div className="d-flex flex-column text-center justify-content-center align-items-center py-5">
                                <div className="metamask_logo">
                                    <img src={MetamaskLogo} alt="metamask" style={{ width: 150 }} />
                                </div>
                                <h1 className="mt-4">No NFT Token</h1>
                            </div>
                        )}
                    </CardBody>
                </Card>
            </div>
        </React.Fragment>
    )
}

export default Collectibles
